import { DiscountTypes } from "@/common/enums";

export default class StripeSettingsModel {
    accountId: string = "";    
}
